export const DUMMY_FOLDER_ID = '68e9095b3007aa58d8f36178';
export const DUMMY_MISSION_ID = '68e90a243007aa58d8f3619a';
export const DUMMY_ORGANIZATION_ID = '68e908c53007aa58d8f36153';
export const DUMMY_PERSON_ID = '68e909173007aa58d8f36163';

export const DUMMY_FOLDER_CODE = 'DOSSIER_DUMMYORG_21000_20251010';
export const DUMMY_MISSION_CODE = 'MISSION_DUMMYORG_21000_20251010';
export const DUMMY_ORGANIZATION_CODE = 'DUMMYORG';
export const DUMMY_PERSON_CODE = 'DUMMYPERSON';

export const DUMMY_MEMO = 'DUMMY - FOR TECHNICAL USE ONLY';
